<template>
  <v-dialog
    scrollable
    v-model="visable"
    max-width="600px"
    :persistent="true"
    content-class="elevated-dialog"
  >
    <v-card class="professional-confirm-dialog">
      <v-card-title  class="dialog-header gradient-bg" style="color: white; font-size: 16px;">
        {{ loading ? '正在提交…': '确认提交？' }}
      </v-card-title>

      <v-divider></v-divider>
      <v-progress-linear class="progress-bar"  :indeterminate="true" :active="loading" height="2"/>

      <v-card-text class="dialog-content">
        <p class="message-text">{{ message }}</p>
        <v-divider/>
        <div>
          <v-textarea
            label="备注信息"
            counter="200"
            v-model="note"
          />
        </div>
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-spacer/>
        <v-btn
            @click.native="$emit('input', false)"
            class="cancel-btn"
        >
          <v-icon left>close</v-icon>
          取消
        </v-btn>
        <v-btn
            color="primary"
            @click.native="onSubmit"
            class="submit-btn"
            :disabled="loading"
            depressed
            dark
        >
          <v-icon left>check</v-icon>
          {{ loading ? '提交中...' : '提交' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    model: {
      prop: 'visable',
      event: 'input'
    },

    props: ['visable', 'message', 'uri', 'dbid'],

    data() {
      return {
        loading: false,
        note: ''
      }
    },

    methods: {
      onSubmit() {
        const vm = this;
        this.loading = true;
        const param = window.xutil.param("note", this.note);
        this.axios.put(`${this.uri}/submit/${this.dbid}`, param)
          .then(rsp => {
            vm.$emit('ok', rsp.data);
            vm.$emit('input', false);
            vm.loading = false;
          });
      }
    }
  }
</script>
<style scoped>
/* 对话框整体样式 */
.professional-confirm-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}

/* 标题栏样式 */
.dialog-header {
  padding: 20px 24px 12px !important;
  position: relative;
}

.gradient-bg {
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
}

.dialog-title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  display: block;
  width: 100%;
  margin-bottom: 12px;
}

.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0;
  width: 100%;
}

/* 内容区域样式 */
.dialog-content {
  padding: 24px !important;
}

.message-text {
  font-size: 15px;
  color: #555;
  margin-bottom: 16px;
}

.note-textarea >>> .v-input__slot {
  border-radius: 8px !important;
  border-color: #e0e0e0 !important;
  transition: border-color 0.3s;
}

.note-textarea >>> .v-input__slot:hover {
  border-color: #bdbdbd !important;
}

.note-textarea >>> .v-input__slot:focus-within {
  border-color: #4a6cf7 !important;
  box-shadow: 0 0 0 2px rgba(74, 108, 247, 0.2);
}

/* 按钮样式 */
.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #f0f0f0;
}

.cancel-btn {
  color: #666 !important;
  min-width: 100px;
  height: 42px;
  border-radius: 6px;
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.05) !important;
  color: #333 !important;
}

.submit-btn {
  min-width: 120px;
  height: 42px;
  border-radius: 6px;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  box-shadow: 0 2px 6px rgba(74, 108, 247, 0.3);
  transition: all 0.3s;
}

.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 108, 247, 0.4);
}

.submit-btn.v-btn--disabled {
  background: #e0e0e0 !important;
  box-shadow: none !important;
}
</style>
